<template>
  <div class="outer-body">
    <!--macc-->
    <!--macc-->
    <div v-if="isShowMockMacc" style="height: 100%;width:100%">
      <mock-macc :data="data"></mock-macc>
    </div>
    <div v-if="isShowCpaAcc" style="height: 100%;width:100%">
      <cpa-acc v-if="isShowCpaAcc" :data="data"></cpa-acc>
    </div>
    <div v-if="isShowTeacher" style="height: 100%;width:100%">
      <teacher v-if="isShowTeacher" :data="data" :courseType="this.data.classesProp"> </teacher>
    </div>
    <!--初级-->
    <div v-if="isShowMockMiddle" style="height: 100%;width:100%">
      <mock-middle v-if="isShowMockMiddle" :data="data"></mock-middle>
    </div>
    <!--税务师-->
    <!-- <app-mock-middle *ngSwitchCase="18" [data]="data"></app-mock-middle> -->
    <!-- 会计实务信息化应用能力考试（管理会计方向）-->
    <div v-if="isShowKjswMacc" style="height: 100%;width:100%">
      <kjsw-macc v-if="isShowKjswMacc" :data="data"></kjsw-macc>
    </div>
    <!-- 实训：出纳 -->
    <div v-if="isShowPractice" style="height: 100%;width:100%">
      <practice v-if="isShowPractice" :data="data"></practice>
    </div>
    <div v-if="isShowDesignPractice" style="height: 100%;width:100%">
      <design-practice :planclassesId="planclassesId" :classesId="classesId" v-if="isShowDesignPractice" :data="data"
                       :list="getData(data,'url')"></design-practice>
    </div>
    <!-- 执业药师职业资格考试模拟作答系统 -->
    <div v-if="isShowZyys" style="height: 100%;width:100%">
      <zyys-acc v-if="isShowZyys" :data="data"></zyys-acc>
    </div>
    <div v-if="!isShowDesignPractice&&!isShowPractice&&!isShowKjswMacc&&!isShowMockMiddle&&!isShowTeacher&&!isShowCpaAcc&&!isShowMockMacc&&!isShowZyys" style="height: 100%;width:100%">
      <div class="main-content" >
        <img class="bg-img" :src="`${assetsUrl}imgs/course/agent-practice.jpg`">
        <div class="course-info">
          <h1 style="font-size: 32px;"> {{ data.classesName }} </h1>
          <a class="border-white enter-btn" :href="data.classesUrls[0].url" target="_blank">
            <span class="btn-left">Learn More
              <i class="anticon anticon-arrow-right"></i>
            </span>
            <span class="btn-right">开始练习</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MockMacc from './mock-macc/index.vue'
import Practice from './practice/index.vue'
import teacher from './course-teacher/index.vue'
import cpaAcc from './cpa-acc/index.vue'
import mockMiddle from './mock-middle/index.vue'
import kjswMacc from './kjsw-macc/index.vue'
import designPractice from './design-practice/index.vue'
import zyysAcc from './zyys-acc/index.vue'

export default {
  name: 'Mock',
  components: {
      Practice,
      MockMacc,
      teacher,
      cpaAcc,
      mockMiddle,
      kjswMacc,
      designPractice,
      zyysAcc
  },
  data() {
    return {
      newData: {
        classesProp: '',
      },
      assetsUrl: 'https://static.51lss.com/o2ostu/assets/'
    }
  },
  props: {
    planclassesId: {
      type: String,
      required: false,
      default: ''
    },
    classesId: {
      type: String,
      required: false,
      default: ''
    },
    data: {
      type: Object,
      required: false,
      default: null,
    },

  },
  // watch: {
  //   data: function(newVal) {
  //     console.log(newVal)
  //     this.newData = newVal
  //   }
  // },
  created() {
    console.log(this.data.courseType, this.isShowTeacher)
    // this.data.courseType = '998'
  },
  computed: {
    isShowMockMacc() {
      return ['12'].includes(this.data.courseType)
    },
    isShowCpaAcc() {
      return ['10', '110'].includes(this.data.courseType)
    },
    isShowTeacher() {
      return ['11', '18', '121', '122', '123', '1611', '1612', '200', '201', '202', 'accKjzk', 'accKjbk', 'accGsglzk', 'accGsglbk', 'accHyyzk', 'accHyybk', 'accXzglzk', 'accXzglbk', 'accXlzk', 'accQtzy', '7102', '7101'].includes(this.data.courseType)
    },
    isShowMockMiddle() {
      return ['16', '141', '142'].includes(this.data.courseType)
    },
    isShowKjswMacc() {
      return ['997', '998', '999', '1000', '1001'].includes(this.data.courseType)
    },
    isShowPractice() {
      return ['8f83244ef13daeeb5ea2a49d93cd1767', '6e7323f6f6a35ca250cfd2eceea63217', 'f9d223ffa59902fab7fbc27258ff7a77', '456cfb8eb8535264912bcd6c0c779dce', 'e0e93204598e8d81c1e2a731135ae2e9', 'fe5ce168c81cb656e1e6119b1a3de8d7', '5aa74b04f8daa50f8f1e7aa30f6f979c', '6b20f8d3812e3a697c02498a08c8cd05'].includes(this.data.courseType)
    },
    isShowDesignPractice() {
      return ['480a1938d20311ea89e0fa163ea75ce5'].includes(this.data.courseType)
    },
    /** 执业药师职业资格考试模拟作答系统 */
    isShowZyys() {
      return ['1710'].includes(this.data.courseType)
    },
  },
  methods: {
    getData(data) {
      console.log('data', data)
      if (data && data.list) {
        if (data.list.length > 0) {
          return data.list
        }
      }
      return ''
    },
  },
}
</script>
<style scoped lang="less">
.outer-body {
//   width: 1200px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: auto;
  position: relative;
}
.btn-menu {
  background: #00abff;
  width: 33.2rem;
  box-shadow: 0 0 0.5rem #999;
  display: flex;
  min-height: 300px;
  flex-direction: column;
  justify-content: center;
  p {
    font-size: 30px;
    text-align: center;
    padding: 20px;
    color: #fff;
  }
}
.enter-btn {
  padding-bottom: 30px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  color: #fff;

  a {
    margin: 10px;
  }

  button {
    background-color: white;
    color: #208ca5;
    font-size: 1.1rem;
    -webkit-box-shadow: 0px 3px 0px #b1dbd9;
    box-shadow: 0px 3px 0px #b1dbd9;
    height: 3.3rem;
    width: 15.8rem;
    border: none;
    font-size: 1rem;
    border-radius: 1.5rem;
    line-height: 3.3rem;
  }
}

.middle-main {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
  position: relative;
}
.full-main {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
}
.back-img {
  height: 100%;
  max-width: 100%;
  display: inline-block;
}
.background-black {
  padding: 30px;
  text-align: center;
  background-color: rgba(0,0,0, 0.6);
  z-index: 2;
  h2 {
    color: #ffffff;
  }
}
.orange-radius {
  background-color: #ff9a2b;
  font-weight: bold;
  padding: 8px 40px;
  font-size: 18px;
  border-radius: 35px;
  color: #ffffff;
  border: none;
  margin: 5px 5px 0 0;
  &:hover {
    transform: scale(1.1, 1.1);
  }
}

button:focus {
  outline: 0 !important;
}
.button-flex {
  display: flex;
  flex-wrap: wrap;
  padding-top: 20px;
}
.main-content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background: #002;
  .enter-btn {
    margin: 30px;
    color: #fff;
    border: 1px solid #fff;
    font-size: 18px;
    border-radius: 5px;
    display: inline-block;
    padding: 0;
    span {
      display: inline-block;
    }
    .btn-left {
      padding: 10px;
    }
    .btn-right {
      background-color: #002693;
      padding: 10px 20px;
      border-radius: 4px;
    }
  }
  h1 {
    color: #fff;
  }
  .bg-img {
    position: absolute;
    // top: 0;
    // bottom: 0;
    // left: 0;
    // right: 0;
    z-index: 1;
  }
}
.course-info {
  display: flex;
  align-items: center;
  flex-direction: column;
  z-index: 99;
}
</style>
